import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { WAVEFORM_ACTIVE_USER } from 'constants/events';
import { UserPropertyEnum } from 'constants/userProperties';
import * as analytics from 'utilities/analytics';

import { useUpdateUserProperty, useUserProperty } from 'hooks/userProperties';
import { selectEligibleForWaveform } from 'selectors/shareVideo';

export const WaveformExperiment = () => {
  const { value: shouldConsiderForWaveformExp, loading } = useUserProperty(
    UserPropertyEnum.CONSIDER_FOR_WAVEFORM_EXP
  );

  const { updateUserProperty } = useUpdateUserProperty(
    UserPropertyEnum.CONSIDER_FOR_WAVEFORM_EXP,
    {
      onCompleted: () => analytics.track(WAVEFORM_ACTIVE_USER),
    }
  );

  const isEligibleForWaveform = useSelector(selectEligibleForWaveform);

  useEffect(() => {
    if (!shouldConsiderForWaveformExp && isEligibleForWaveform && !loading) {
      updateUserProperty(true);
    }
  }, [shouldConsiderForWaveformExp]);

  return null;
};
